import { number, oneOf, shape, string } from 'prop-types'
import { AccountTypes } from '../../models/current-user/account-types-enum'

/**
 * @typedef {Object} Account
 * @property {string} [accountId]              - account ID
 * @property {string} [accountType]            - type of account
 * @property {number} [activeObjects]          - size of the fleet
 * @property {string} [name]                   - account name
 * @property {string} [providerNumber]         - number of provider (organization level above account)
 */
export const accountPropType = shape({
    accountId: string,
    accountType: oneOf(Object.values(AccountTypes)),
    activeObjects: number,
    name: string,
    providerNumber: string
})
